function numberToLetter(num) {
  if (num < 0 || num > 25) return null;
  return String.fromCharCode(97 + num);
}

export default numberToLetter;
